<template>
  <vs-card>
    <div slot="header">
      <h3>Fotos da vistoria</h3>
    </div>
    <vs-row
      v-if="listArquivosVistoria && listArquivosVistoria.length > 0"
      class="mt-5"
      vs-justify="center"
    >
      <vs-col
        v-for="item in listArquivosVistoria"
        :key="item.id"
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="3"
        vs-sm="3"
        vs-xs="12"
        class="mb-4"
      >
        <vs-card>
          <div slot="header">
            <h3>
              {{ item.nomePosicao }}
            </h3>
          </div>
          <div>
            <div v-if="item.endereco" class="m-2 mb-4" style="clear: both">
              <vs-button
                v-tooltip="'Visualizar Mapa'"
                v-if="item.latitude"
                @click="openModalMap(item)"
                class="float-left mr-2"
                type="gradient"
                color="primary"
                icon-pack="feather"
                icon="icon-map-pin"
              ></vs-button>
              <span v-if="item.nome">
                <span v-if="validTypeOfEndereco(item.endereco)">{{
                  item.endereco
                }}</span>
                <span v-else
                  >{{ item.endereco.road }} -
                  {{ item.endereco.neighbourhood }}
                  {{ item.endereco.city }} / {{ item.endereco.state }}</span
                >
                <p v-if="item.dataFoto">
                  Sincronizada em:
                  {{
                    verificaSefotoFoiAtualizada(
                      item.dataFoto,
                      item.dataAtualizacao,
                    )
                  }}
                </p>
                <p v-if="item.dataFotoCaptura">
                  Capturada em:
                  {{ formataData(item.dataFotoCaptura) }}
                </p></span
              >
            </div>
            <div
              v-if="item.userUploadedName"
              class="m-2 mb-4"
              style="clear: both"
            >
              Upload por: {{ item.userUploadedName }}
            </div>

            <video
              class="video"
              style="max-height: 130px; margin: auto; display: flex"
              v-if="verificaExtensaoVideo(item.nome)"
              controls
              muted
              loop
              :src="item.nome"
            ></video>

            <img
              @click="openModalFoto(item)"
              v-if="verificaExtensaoImagem(item.nome)"
              :src="item.nome"
              class="foto cursor-pointer"
              width="100%"
            />

            <div
              v-else-if="!verificaExtensaoVideo(item.nome)"
              class="flex flex-col items-center"
            >
              <img
                class="foto cursor-pointer"
                width="80%"
                src="../../../../../../src/assets/images/elements/PDF_file_icon2.png"
              />
              <a :href="item.nome" target="_blank">{{
                formataUrlLink(item.nome)
              }}</a>
            </div>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>

    <!-- Mapa -->
    <vs-popup
      title="Local da Foto"
      :active.sync="openModalMapa"
      @close="itemMapaModal = null"
    >
      <iframe
        v-if="itemMapaModal"
        width="100%"
        height="170"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        :src="`https://maps.google.com/maps?q=${itemMapaModal.latitude},${itemMapaModal.longitude}&hl=pt-br&z=15&amp;output=embed`"
      ></iframe>
    </vs-popup>

    <!-- Foto -->
    <vs-popup
      :fullscreen="true"
      v-if="imgModal"
      title="Foto"
      :active.sync="openModal"
      @close="closePop"
    >
      <div class="flex justify-center m-5">
        <h4>
          {{ itemModal.nomePosicao }}
        </h4>
      </div>
      <div class="flex justify-center m-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="2"
          class="sm:p-2 p-4 gap-x-1 z-40"
        >
          <vs-button
            icon-pack="feather"
            icon="icon-arrow-left"
            color="warning"
            class="z-40"
            @click="mudaFoto('anterior')"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          class="sm:p-2 p-4 gap-x-1 z-40"
        >
          <vs-button
            icon-pack="feather"
            icon="icon-rotate-ccw"
            color="primary"
            class="z-40"
            @click="rotateLeft"
          />
          <div class="z-40 bg-white px-3 rounded flex flex-col items-center">
            <span>Zoom</span>
            <vs-switch color="success" v-model="zoomFotoSwitch">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
          <vs-button
            icon-pack="feather"
            icon="icon-rotate-cw"
            color="primary"
            class="z-40"
            @click="rotateRight"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="2"
          class="sm:p-2 p-4 gap-x-1 z-40"
        >
          <vs-button
            icon-pack="feather"
            icon="icon-arrow-right"
            color="warning"
            class="z-40"
            @click="mudaFoto('próximo')"
          />
        </vs-col>
      </div>
      <vs-row
        vs-type="flex"
        class="w-full flex justify-center items-center mx-auto"
      >
        <vs-col
          :style="{
            height: zoomFotoSwitch ? '204.8rem' : '102.4rem',
            width: zoomFotoSwitch ? '204.8rem' : '102.4rem',
          }"
          vs-type="flex"
          vs-justify="center"
          vs-w="12"
          class="sm:p-2 p-4"
        >
          <img
            class="h-full w-full object-contain"
            :style="{ transform: 'rotate(' + rotationAngle + 'deg)' }"
            v-if="verificaExtensaoImagem(imgModal)"
            :src="imgModal"
            width="100%"
            height="100%"
            style="max-width: 100%; max-height: 100%; object-fit: contain"
          />
          <video
            class="video h-full w-full object-contain"
            :style="{ transform: 'rotate(' + rotationAngle + 'deg)' }"
            style="max-height: 800px; margin: auto; display: flex"
            v-if="verificaExtensaoVideo(imgModal)"
            controls
            muted
            loop
            :src="imgModal"
          ></video>
        </vs-col>
      </vs-row>
    </vs-popup>
  </vs-card>
</template>

<script>
import moment from 'moment';

export default {
  props: ['listArquivosVistoria'],
  data() {
    return {
      openModal: false,
      imgModal: null,
      itemModal: null,
      openModalMapa: false,
      itemMapaModal: null,
      itemModalIndex: 0,
      rotationAngle: 0,
      zoomFotoSwitch: false,
    };
  },
  methods: {
    formataData(data) {
      const formattedDate = moment(data).format('DD/MM/YYYY HH:mm');

      return formattedDate;
    },
    formataUrlLink(url) {
      if (url) return url.split('/').pop();
    },
    ajustaDataHoraUtc(data) {
      const adjustedDateHourUtc = moment
        .utc(data)
        .local()
        .format('DD/MM/YYYY HH:mm');

      return adjustedDateHourUtc;
    },
    validTypeOfEndereco(item) {
      const isItemString = typeof item === 'string';

      return isItemString;
    },
    verificaSefotoFoiAtualizada(dataCriacao, dataAtualizacao) {
      const fotoFoiAtualizada =
        moment(dataCriacao).format('YYYYMMDDHHMMSS') ===
        moment(dataAtualizacao).format('YYYYMMDDHHMMSS');

      const _dataFoto = !fotoFoiAtualizada
        ? this.ajustaDataHoraUtc(dataAtualizacao)
        : this.ajustaDataHoraUtc(dataCriacao);

      return _dataFoto;
    },
    verificaExtensaoVideo(link) {
      if (!link) {
        return false;
      }

      if (link) {
        const isVideoLink = link.split('/')[0] === 'data:video';

        if (isVideoLink) return true;
        const extension = link.split('.').pop();
        this.tipoFoto = extension;

        const isVideoExtension =
          extension === 'gif' ||
          extension === 'mp4' ||
          extension === 'webm' ||
          extension === 'quicktime';

        if (!isVideoExtension) {
          return false;
        }

        return true;
      }
    },
    verificaExtensaoImagem(link) {
      if (!link) {
        return false;
      }

      if (link) {
        const isImageLink = link.split('/')[0] === 'data:image';

        if (isImageLink) return true;
        const extension = link.split('.').pop();
        this.tipoFoto = extension;

        const isImageExtension =
          extension === 'png' ||
          extension === 'jpeg' ||
          extension === 'jpg' ||
          extension === 'gif';

        if (!isImageExtension) {
          return false;
        }

        return true;
      }
    },
    openModalMap(item) {
      this.itemMapaModal = item;
      this.openModalMapa = true;
    },
    openModalFoto(item) {
      this.imgModal = item.nome;
      this.itemModal = item;
      this.openModal = true;
    },
    closePop() {
      this.openModal = false;
    },
    mudaFoto(param) {
      const currentIndex = this.arquivos.findIndex(
        (image) =>
          image.idEventoFoto === this.itemModalSelecionado.idEventoFoto,
      );

      const updatedIndex =
        param === 'próximo'
          ? (currentIndex + 1) % this.arquivos.length
          : param === 'anterior'
          ? (currentIndex - 1 + this.arquivos.length) % this.arquivos.length
          : currentIndex;

      this.itemModalSelecionado = this.arquivos[updatedIndex];
      this.openModalDetalhes(this.itemModalSelecionado);
    },
    rotateLeft() {
      this.rotationAngle -= 90;
    },
    rotateRight() {
      this.rotationAngle += 90;
    },
    toggleZoom() {
      this.zoomFotoSwitch = !this.zoomFotoSwitch;
    },
  },
};
</script>
